<template>
  <b-modal
    id="validate_otp"
    :centered="true"
    no-close-on-backdrop
    size="sm"
    class="add-member-modal"
    :title="`Validate ${identifierTypeText} via OTP`"
    :hide-footer="true"
    @hidden="closeModal"
    v-model="isOpen"
    ref="otpModal"
    @shown="resetValidationState"

  >
    <form action="#">
      <div class="verifyOTPContent mb-4 ">
        <div class="header-content mb-4">
          <h6 class="mb-1">Verify OTP</h6>
          <div class="text-muted mb-2">
            Validate your {{ identifierTypeText }} via OTP <br />
            OTP has been sent to
            <strong class="text-dark">{{ identifier }}</strong>
          </div>
        </div>
        <div class="OtpWrapper">
          <label for="">Please enter the 6 digit OTP:</label>
          <div class="d-flex mb-4 otp-inputs-wrapper align-items-center pb-2">
            <!-- <input maxlength="1" min="0" max="9" class="form-control otp-input" />
                        <input maxlength="1" min="0" max="9" class="form-control otp-input" />
                        <input maxlength="1" min="0" max="9" class="form-control otp-input" />
                        <input maxlength="1" min="0" max="9" class="form-control otp-input" />
                        <input maxlength="1" min="0" max="9" class="form-control otp-input" />
                        <input maxlength="1" min="0" max="9" class="form-control otp-input" />
                        <input maxlength="1" min="0" max="9" class="form-control otp-input" />
                        <input maxlength="1" min="0" max="9" class="form-control otp-input" />
                        <input maxlength="1" min="0" max="9" class="form-control otp-input" />
                        <input maxlength="1" min="0" max="9" class="form-control otp-input" /> -->
            <input
              v-for="(digit, index) in otpDigits"
              :key="index"
              v-model.number="otpDigits[index]"
              class="form-control otp-input"
              maxlength="1"
              min="0"
              max="9"
              @input="handleOtpInput(index, $event)"
              @keydown.delete="handleOtpDelete(index, $event)"
              @keydown="preventNonNumeric($event)"
              @paste="handlePaste($event)"
              ref="otpInputs"
              :disabled="otpVerified"
            />
          </div>
        </div>
      </div>
      <div class="btn-wrapper mt-3 d-flex flex-column gap-16">
        <button
          type="submit"
          class="primaryBtn w-100"
          @click.prevent="verifyOtp"
          :disabled="!isOtpComplete || otpVerificationInProgress || otpVerified"
        >
          <span v-if="otpVerificationInProgress">
            <b-spinner small type="grow" />
            Verifying...</span
          >
          <span v-else-if="otpVerified">Verified</span>
          <span v-else>Verify OTP</span>
        </button>

        <div
          v-if="
            otpValidationMessage?.message && otpAttempted
          "
          class="otp-message-container mt-2 form-group"
        >
          <div :class="['validate-message', otpValidationMessage.type]">
            <div
              :class="[
                'message-indicator',
                `${otpValidationMessage.type}-indicator`,
              ]"
            ></div>
            <span class="message-text">
              <strong :class="`${otpValidationMessage.type}-text`">{{
                otpValidationMessage.title
              }}</strong>
              -
              {{ otpValidationMessage.message }}
            </span>
          </div>
        </div>

        <div class="d-flex align-items-center gap-16  flex-column flex-md-row">
          <button
            type="button"
            class=" btn-secondary w-100"
            @click="closeModal"
          >
            Cancel
          </button>

          <button
            type="button"
            class="primaryBtn w-100 border-0"
            @click="saveChanges"
            :disabled="!canSaveChanges"
          >
            Save Changes
          </button>
        </div>
      </div>
    </form>
  </b-modal>
</template>
<script>
import axios from "axios";
export default {
  name: "MemberAdminOTP",

  props: {
    identifier: {
      type: String,
      default: "example@email.com",
    },
    type: {
      type: String,
      default: " ", // "email" or "phone"
      validator: (value) => ["email", "phone"].includes(value),
    },
    value: {
      type: Boolean,
      default: false,
    },

    // using the props to show the type of identifier passed from the DownlineRepPerdonalInfo.vue
    identifierTypeText: {
      type: String,
      default: "email",
    },
  },
  data() {
    return {
      otpDigits: Array(6).fill(""), // Initialize with 6 empty strings
      otpVerified: false,
      otpAttempted: false,
      otpVerificationInProgress: false,
      otpValidationMessage: null,
    };
  },

  methods: {
    handleOtpInput(index, event) {
      // Sanitize input to numbers only
      const sanitizedValue = event.target.value.replace(/\D/g, "");
      this.otpDigits[index] = sanitizedValue;

      // Ensure only one digit is entered
      if (event.target.value.length > 1) {
        this.otpDigits[index] = event.target.value.slice(0, 1);
        return;
      }

      // Move to next input when a digit is entered
      if (sanitizedValue && index < 5) {
        this.$nextTick(() => {
          this.$refs.otpInputs[index + 1].focus();
        });
      }

      // Emit complete event if all digits filled
      if (this.otpDigits.every((d) => d) && index === 5) {
        this.$emit("complete", this.otpDigits.join(""));
      }
    },

    handleOtpDelete(index, event) {
      // Move to previous input when backspace is pressed on an empty field
      if (!event.target.value && index > 0) {
        this.$nextTick(() => {
          this.$refs.otpInputs[index - 1].focus();
        });
      }
    },
    preventNonNumeric(event) {
      // Allow: backspace, delete, tab, escape, enter
      if (
        [8, 9, 13, 27, 46].includes(event.keyCode) ||
        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (event.ctrlKey && [65, 67, 86, 88].includes(event.keyCode)) ||
        // Allow: left/right arrows
        (event.keyCode >= 37 && event.keyCode <= 40)
      ) {
        return;
      }

      // Block non-numeric keys
      if (
        (event.keyCode < 48 || event.keyCode > 57) && // 0-9
        (event.keyCode < 96 || event.keyCode > 105) // Numpad 0-9
      ) {
        event.preventDefault();
      }
    },
    handlePaste(event) {
      event.preventDefault();

      const pastedText = (event.clipboardData || window.clipboardData).getData(
        "text"
      );

      const numericText = pastedText.replace(/[^0-9]/g, "");

      const otpText = numericText.slice(0, 6);

      this.fillOtpInputs(otpText);
    },
    fillOtpInputs(otpText) {
      this.otpDigits = Array(6).fill("");

      for (let i = 0; i < Math.min(otpText.length, 6); i++) {
        this.otpDigits[i] = otpText[i];
      }

      const focusIndex = Math.min(otpText.length, 5);
      this.$nextTick(() => {
        if (this.$refs.otpInputs && this.$refs.otpInputs[focusIndex]) {
          this.$refs.otpInputs[focusIndex].focus();
        }
      });
    },

    // method to handle the OTP verification
    async verifyOtp() {
      let loader = this.$loading.show();
      this.otpVerificationInProgress = true;
      this.otpAttempted = true;

      try {
        const response = await axios.post(
          process.env.VUE_APP_CORENROLL_SYSTEM_API_V2 + "verify-common-otp",
          {
            no_attempt_limit: 1,
            contact: this.identifier,
            type: this.identifierTypeText,
            otp: parseInt(this.otpDigits.join("")),
          }
        );

        if (
          response.data.success === true ||
          response.data.status === "success" ||
          response.data.verified === true
        ) {
          this.otpVerified = true;
          this.otpValidationMessage = {
            type: "success",
            title: "OTP Verified",
            message: "Your OTP has been successfully verified.",
          };
          this.$notify("OTP verified successfully!");
          this.canSaveChanges = true; // Enable save changes button
        } else {
          this.otpVerified = false;
          this.otpValidationMessage = {
            type: "error",
            title: "OTP Verification Failed",
            message: response.data.message || "Invalid OTP. Please try again.",
          };
        }
      } catch (error) {
        console.error("OTP verification error:", error);
        this.otpVerified = false;

        if (error.response?.data?.message.includes("Failed to verfy OTP")) {
          this.$notify("Invalid OTP. Please try again.", "error");
          this.otpVerified = false;

          this.otpValidationMessage = {
            type: "error",
            title: "Verification Failed",
            message: "Invalid OTP. Please try again.",
          };
        } else {
          this.$notify(
            "OTP verification failed. an unexpected error occured",
            "error"
          );
        }
      } finally {
        this.otpVerificationInProgress = false;
        loader.hide();
      }
    },

    closeModal() {
      this.$emit('close');
      this.isOpen = false;
      this.$refs.otpModal.hide();
      this.resetValidationState();
    },

     resetValidationState() {
          this.$nextTick(() => {
      this.$refs.otpInput?.focus();
    });
      this.otpDigits = Array(6).fill("");
      this.otpVerified = false;
      this.validationStatus = null;
      this.otpValidationMessage = null;
      this.validationInProgress = false;
      this.otpVerificationInProgress = false;
      this.otpAttempted = false;
   
      this.canSaveChanges = false; // Disable save changes button
    },
    saveChanges() {
     if (this.otpVerified) {
    this.$emit('save', { 
      verified: true,
      identifier: this.identifier,
      type: this.identifierTypeText
    });
    this.closeModal();
  }
},

  },
  computed: {
    isOpen: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    isOtpComplete() {
      return this.otpDigits.every((d) => d !== "");
    },

    canSaveChanges() {
      if (this.loading) return false;

      if (this.otpVerified) {
        return true;
      } else {
        return false;
      }
    },


  },

  watch: {
    isOpen(newVal) {
      if (!newVal) {
        this.resetValidationState();
      }
    },
  },
};
</script>
